import createVueComponent from '../createVueComponent';
var FileWarning = createVueComponent('FileWarningIcon', [['path', {
  d: 'M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z',
  key: '1nnpy2'
}], ['path', {
  d: 'M12 9v4',
  key: 'juzpu7'
}], ['path', {
  d: 'M12 17h.01',
  key: 'p32p05'
}]]);
export default FileWarning;